import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { ParsedEnvVariables, storeNames } from './config/config.type.ts';

export interface ConfigStoreState extends ParsedEnvVariables {
  loaded: boolean;
  initStarted?: boolean;
  error?: string | null;
}
export const useConfigStore = create(
  persist<ConfigStoreState>(
    () => ({
      imageTag: undefined,
      env: undefined,
      portableMode: undefined,
      clusterName: undefined,
      defaultSite: undefined,
      videoRecallDisabled: false,
      loaded: false,
      initStarted: false,
      error: null,
    }),

    {
      name: storeNames.config,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
